export default {
  apiUrl: 'https://api.drillwurks.com/api/v1/',
  qbUrl: 'https://api.drillwurks.com/api/v1/qb/auth'
};
